import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { CustomButton } from '../../models/customButton';
import { CustomTableButtonComponent } from '../custom-table-button/custom-table-button.component';

@Component({
  selector: 'app-custom-table-icon',
  standalone: true,
  imports: [
    CommonModule, FormsModule, TableModule, InputTextModule,
    ButtonModule, IconFieldModule, InputIconModule, CustomTableButtonComponent
  ],
  templateUrl: './custom-table-icon.component.html',
  styleUrl: './custom-table-icon.component.scss'
})
export class CustomTableIconComponent implements OnChanges {
  @Input() elements: any[] = [];
  @Input() headers: any[] = [];
  @Input() hasButton: boolean = false;
  @Input() iconColumn: string = '';
  @Input() iconName: string = '';
  @Input() iconNameSelect: string = '';
  @Input() hasFilter: boolean = false;
  @Input() selectAllItemsButton: boolean = true;
  @Input() actions: CustomButton[] = [];
  @Input() selectOnlyOne: boolean = false;
  @Input() emptyTableMessage = 'No hay elementos para visualizar';
  @Output() dataSelect: EventEmitter<any> = new EventEmitter<any>();

  tableData: any[] = [];
  globalFilter: string = '';

  get visibleHeaders() {
    return this.headers.filter(h => h.visible);
  }

  get filterFields(): string[] {
    return this.visibleHeaders.map(h => h.key);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.tableData = this.elements;
  }

  selectAll() {
    const check = !this.tableData.some(d => d.type === 2);
    this.tableData.forEach(data => {
      if (check && data.type === 0) data.type = 2;
      else if (check && data.type === 4) data.type = 1;
      else if (!check && data.type === 2) data.type = 0;
      else if (!check && data.type === 1) data.type = 4;
    });
    this.dataSelect.emit(this.elements);
  }

  selectOne(data: any) {
    if (this.selectOnlyOne) {
      this.elements.forEach(el => {
        el.type = el === data ? (el.type === 2 ? 0 : 2) : 0;
      });
    } else {
      if (data.type === 0) data.type = 2;
      else if (data.type === 1) data.type = 4;
      else if (data.type === 2) data.type = 0;
      else if (data.type === 4) data.type = 1;
    }
    this.dataSelect.emit(this.elements);
  }
}
